<template>
  <div>
    <template v-if="isEdit">
      <b-form-select
        v-if="inputType === 'select'"
        :value="dataTd[valueField]"
        :options="selectOptions"
        :value-field="valueField"
        :text-field="textField"
        @change="(value) => setSelected(value)"
      />
      <Datepicker
        v-else-if="inputType === 'datepicker'"
        :bootstrap-styling="true"
        :value="dataTd[textField]"
        @selected="(newValue) => setRowData(
          dataTd,
          textField,
          newValue
        )"
        :format="formatDate"
      />
      <b-form-input
        v-else
        :type="inputType"
        :disabled="disabledInput"
        v-model="dataTd[textField]"
      />
    </template>
    <div v-else>
      <LabelTableStatus v-if="labelStatus" :status="dataTd" :center-item="false" />
      <span v-else>
        {{ dataTd[textField] }}
      </span>

    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import LabelTableStatus from '@components/tables/elements/LabelTableStatus'

export default {
  name: 'TDWithChange',
  components: {
    Datepicker,
    LabelTableStatus
  },
  props: {
    dataTd: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String
    },
    formatDate: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    selectOptions: {
      type: [Array, Object]
    },
    valueField: {
      type: String,
      default: 'id'
    },
    textField: {
      type: String,
      default: ''
    },
    labelStatus: {
      type: Boolean,
      default: false
    },
    checkCurrencyValues: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isEdit (v) {
      this.isEdit = v
    },
    dataTd: {
      handler () {
        this.checkCurrency()
      },
      deep: true
    }
  },
  data () {
    return {
      disabledInput: false
    }
  },
  mounted () {
    this.checkCurrency()
  },
  methods: {
    setRowData (date, type, newValue) {
      date[type] = this._toLocalTime(newValue)
    },
    setSelected (val) {
      this.$emit('changeSelect', { id: val })
      this.checkCurrency()
    },
    checkCurrency () {
      if (this.checkCurrencyValues) {
        for (let key in this.dataTd) {
          if (Number(this.dataTd[key]) !== 0 && key !== this.textField) {
            this.disabledInput = true
            return
          } else {
            this.disabledInput = false
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>
